export default __webpack_public_path__ + "static/media/home.ea5d6e02.svg";